import { render } from "./CrearCuentaPaciente.vue?vue&type=template&id=60f6c7f2"
import script from "./CrearCuentaPaciente.vue?vue&type=script&lang=js"
export * from "./CrearCuentaPaciente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__